import { useEffect, useState } from "react";
import CommonAsyncSelect from "../../../components/CommonAsyncSelect";

const Select2 = (props) => {
  const data = props.data;
  const locationDate = props?.locationDate?.RowData;
  const [selected, setSelected] = useState("");
  // const [selected, setSelected] = useState(
  //   data?.name == "item_id"
  //     ? { value: locationDate?.item_id, label: locationDate?.item_name }
  //     : data?.name == "godown_id"
  //     ? { value: locationDate?.godown_id, label: locationDate?.godown_name }
  //     : ""
  // );
  useEffect(() => {
    if (locationDate) {
      if (data?.name === "item_id" && locationDate?.item_id) {
        setSelected({
          value: locationDate.item_id,
          label: locationDate.item_name,
        });
        props.handleInput("item_id", locationDate.item_id); // optional: sync value to parent
      } else if (data?.name === "godown_id" && locationDate?.godown_id) {
        setSelected({
          value: locationDate.godown_id,
          label: locationDate.godown_name,
        });
        props.handleInput("godown_id", locationDate.godown_id); // optional
      }
    }
  }, [locationDate]);
  //   const [selected, setSelected] = useState("");
  let UserRole = JSON.parse(localStorage.getItem("inventory")).userData
    ?.role_id;

  console.log("propsopsdsd", props?.data?.name == "branch_id");

  return (
    <>
      <div className="col-md-3">
        <label htmlFor={data.name}>
          {data.label}{" "}
          {(data?.required === false
            ? false
            : data?.required ||
              props?.fields?.date_wise == 1 ||
              (props?.data?.name === "branch_id" && UserRole == 2)) && (
            <span className="text-danger">*</span>
          )}
        </label>
        <CommonAsyncSelect
          cacheOptions
          defaultOptions
          tabSelectsValue
          isClearable={true}
          classNamePrefix="react-select"
          loadOptions={data.values}
          value={props.state?.[data.name] ? selected : ""}
          onChange={(e) => {
            setSelected(e);
            props.handleInput(data.name, e?.value || "");
          }}
          components={{
            IndicatorsContainer: () => null,
          }}
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              minHeight: "0px",
            }),
            valueContainer: (baseStyles, state) => ({
              ...baseStyles,
              paddingTop: "0px",
              paddingBottom: "0px",
            }),
            input: (baseStyles, state) => ({
              ...baseStyles,
              paddingTop: "0px",
              paddingBottom: "0px",
              marginTop: "0px",
              marginBottom: "0px",
              gridTemplateColumns: "0 100%",
            }),
            dropdownIndicator: (baseStyles, state) => ({
              ...baseStyles,
              paddingTop: "0px",
              paddingBottom: "0px",
            }),
            option: (baseStyles, state) => ({
              ...baseStyles,
              paddingTop: "0px",
              paddingBottom: "0px",
            }),
            menu: (baseStyles, state) => ({
              ...baseStyles,
              width: "100%",
            }),
          }}
        />
      </div>
    </>
  );
};

export default Select2;
